module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("W")]), _vm._v("e could not have written this book without the interest and encouragement of many relatives and friends. However, we have to give special thanks to Zvi Schloss for his patient support and helpful advice; to Michael Davies for his erudite research into the chronology of the events of World War II against which the story is set; to Alistair McGechie for his able and sympathetic editing; to Pat Healy for her faith that this book would be published.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We owe much to Frank Entwistle whose constructive suggestions and wise counselling smoothed our way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("And finally to Fritzi Frank our love and grateful thanks for the copious notes and reminders that she gave without reservation.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1733311f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Acknowledgments.vue
// module id = 75
// module chunks = 0